import React from 'react'
// import { ProfileWrap } from "../layout/components/sidebar/style";

const Profile = ({ profileName }) => {
  const initials = profileName?.slice(0, 2).toUpperCase()
  // return <ProfileWrap>{initials}</ProfileWrap>;
  return <b>{initials}</b>
}

export default Profile
